const pin = require('./map_home_spot@2x.svg');

export const PIN_PROPS = {
  iconImageHref: pin,
  iconImageOffset: [-20, -54],
  iconImageSize: [52, 48],
  iconLayout: 'default#image',
};
